/**
 * 报关贴纸管理- 设置贴纸品名
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React,{Fragment} from 'react';
import {Tabs, Spin, Popover, Badge} from "antd";
import {Link} from "react-router-dom";
import ReactContext from "@store/reactContext";
// import CustomsDeclarationStickerSteps from "../Components/CustomsDeclarationStickerSteps";
import Lang from "@/components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import IconFont from "@components/IconFont/index";
import dayjs from 'dayjs';
import "../CustomsDeclarationStickerList.less";

class CustomsCoding extends React.Component{
    static contextType = ReactContext;
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            searchFormOptions:[
                {
                    name:'keyword',
                    cnTitle:'客户',
                    cnTitleId:'KeHu',
                    cnPlaceholder:'请输入客户编码或名称',
                    cnPlaceholderId:'QingShuRuCaiGouShangBianMaHuoMingCheng'
                },
                {
                    name:'poCode',
                    cnTitle:'PO单号',
                    cnTitleId:'PODanHao',
                    cnPlaceholder:'请输入PO单号',
                    cnPlaceholderId:'QingShuRuPODanHao'
                }
            ],
            columns:[
                {
                    cnTitle: '客户信息',
                    dataIndex: 'buyerCode',
                    cnTitleId: 'KeHuXinXi',
                    render: (buyerCode, record) => {
                        return(<Fragment>
                            <p className={'span-red'}><Link to={`/customer/detail?id=${record.buyerId}`} target={'_blank'}>{buyerCode}</Link></p>
                            <p className={'blackLink'}><Link to={`/customer/detail?id=${record.buyerId}`} target={'_blank'}>{record.buyerName}</Link></p>
                        </Fragment>)}
                },
                {
                    cnTitle: 'PO单号',
                    dataIndex: 'poCode',
                    cnTitleId: 'PODanHao',
                },
                {
                    cnTitle: '下单时间',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'XiaDanShiJian',
                    render: (startTime, record) => startTime?dayjs(startTime).format('YYYY-MM-DD HH:mm'):'-'
                },
                {
                    cnTitle: '商品款数',
                    dataIndex: 'poSkuCount',
                    cnTitleId: 'ShangPinKuanShu',
                },
                {
                    cnTitle: '订单提交时长',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'DingDanTiJiaoShiZhang',
                    type:'millisecondToTime',
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<Popover content={Lang({id: 'QuChuLi',default:'去处理'})}>
                        <Link className="link" to={
                            {
                                pathname: '/customsDeclarationSticker/stickerBrandDetail',
                                search: `?${record.id}`,
                            }
                        }>
                            <IconFont
                                type="icon-xiangqing-moren-icon"
                                className="hover-hide"
                                style={{ fontSize: "32px" }}
                            ></IconFont>
                            <IconFont
                                type="icon-xiangqing-xuanzhong-icon"
                                className="hover-show"
                                style={{ fontSize: "32px" }}
                            ></IconFont>
                        </Link>
                    </Popover>)},
            ],
            columnsReviewed:[
                {
                    cnTitle: '客户信息',
                    dataIndex: 'buyerCode',
                    cnTitleId: 'KeHuXinXi',
                    render: (buyerCode, record) => {
                        return(<Fragment>
                            <p className={'span-red'}><Link to={`/customer/detail?id=${record.buyerId}`} target={'_blank'}>{buyerCode}</Link></p>
                            <p className={'blackLink'}><Link to={`/customer/detail?id=${record.buyerId}`} target={'_blank'}>{record.buyerName}</Link></p>
                        </Fragment>)}
                },
                {
                    cnTitle: 'PO单号',
                    dataIndex: 'poCode',
                    cnTitleId: 'PODanHao',
                },
                {
                    cnTitle: '下单时间',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'XiaDanShiJian',
                    render: (poCreateTime, record) => poCreateTime?dayjs(poCreateTime).format('YYYY-MM-DD HH:mm'):'-'
                },
                {
                    cnTitle: '商品款数',
                    dataIndex: 'poSkuCount',
                    cnTitleId: 'ShangPinKuanShu',
                },
                {
                    cnTitle: '处理人',
                    dataIndex: 'handleName',
                    cnTitleId: 'ChuLiRen',
                    render: (handleName, record) => record.handleTime?<Fragment><span>{handleName}</span><span style={{marginLeft:'5px'}}>{dayjs(record.handleTime).format('YYYY-MM-DD HH:mm')}</span></Fragment>:handleName
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<Popover content={Lang({id: 'View',default:'查看'})}>
                        <Link className="link" to={
                            {
                                pathname: '/customsDeclarationSticker/stickerBrandIsView',
                                search: `?${record.id}`,
                            }
                        }>
                            <IconFont
                                type="icon-xiangqing-moren-icon"
                                className="hover-hide"
                                style={{ fontSize: "32px" }}
                            ></IconFont>
                            <IconFont
                                type="icon-xiangqing-xuanzhong-icon"
                                className="hover-show"
                                style={{ fontSize: "32px" }}
                            ></IconFont>
                        </Link>
                    </Popover>)
                },
            ],
            auditStatus:'0',//默认审核状
            total: 0
        }
    }
    /**
     * 改变状态
     **/
    changeTab(activeKey){
        this.setState({
            auditStatus:activeKey
        },()=>{
            switch (activeKey) {
                case '1':
                    if(this.onRefTabChildTwo){
                        this.onRefTabChildTwo.handleFetch()
                    }
                    break;
                case '2':
                    if(this.onRefTabChildThree){
                        this.onRefTabChildThree.handleFetch()
                    }
                    break;
                default:
                    if(this.onRefTabChildOne){
                        this.onRefTabChildOne.handleFetch()
                    }
                    return
            }
        })
    }
    fetchCallBack(res){
        const {success,valid,model} = res;
        if (success && valid) {
            this.setState({
                total:model?model:{},
            })
        }else this.setState({
            total: {}
        })
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    onRefTabTwo = (ref) =>  this.onRefTabChildTwo = ref;
    onRefTabThree = (ref) =>  this.onRefTabChildThree = ref;
    getShow(isHasAuthSave,isHasAuthSubmit,auditStatus){ // 权限问题
        if(!isHasAuthSave&&!isHasAuthSubmit){
            return '1'
        }else if(!isHasAuthSave&&auditStatus=='0'){//auditStatus '0' 待处理  '2' 待审核  1 已处理
            if(isHasAuthSubmit) return '2'
            return '1'
        }else if(!isHasAuthSubmit&&auditStatus=='2'){//auditStatus '0' 待处理  '2' 待审核  1 已处理
            if(isHasAuthSave) return '0'
            return '1'
        }
        return auditStatus
    }
    render(){
        const { loading,searchFormOptions,columns,auditStatus,columnsReviewed,total={} } = this.state;
        const { context={} } = this;
        const __authState = context.__authState||[];
        const isHasAuthSave = __authState.includes('Sticker_Task_Save');
        const isHasAuthSubmit = __authState.includes('Sticker_Task_Submit');
        const currPageName = Lang({id: "SheZhiTieZhiPinPai",default: "设置贴纸品名"});
        return (<Spin tip='loading' spinning={loading}>
                {/*<CustomsDeclarationStickerSteps current={2} />*/}
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className={'customsDeclarationStickerListStyle'}>
                    <Tabs activeKey={this.getShow(isHasAuthSave,isHasAuthSubmit,auditStatus)}
                          items={[
                              isHasAuthSave?{
                                  key: '0',
                                  label:(<div>
                                      <span className="mr_4">{Lang({id: 'DaiChuLi', default: '待处理'})}</span><Badge count={total.waitHandleCount||0}></Badge>
                                  </div>),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columns}
                                                      rowKey={'id'}
                                                      onRef={this.onRefTabOne}
                                                      fetchCallBack={(res)=>this.fetchCallBack(res)}
                                                      flagShowReset={false}
                                                      searchFormOptions={searchFormOptions}
                                                      precondition={{
                                                          eventCode: 40,
                                                          auditStatus:0, // 在待处理 和 待审核 tap页 传 0   ,  在已完成tap页 传1
                                                          saveStatus:0,// 0:未保存(查询未保存过:待处理tap页) 1:未提交(查询保存过未提交:待审核tap页
                                                      }}
                                                      fetchApi={'/service/mg/sticker/track/list'} />
                                  </div>)
                              }:null,isHasAuthSubmit?{
                                  key: '2',
                                  label:(<div>
                                      <span className="mr_4">{Lang({id: 'DaiShenHe', default: '待审核'})}</span><Badge count={total.waitAuditCount||0}></Badge>
                                  </div>),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columns}
                                                      rowKey={'id'}
                                                      onRef={this.onRefTabThree}
                                                      fetchCallBack={(res)=>this.fetchCallBack(res)}
                                                      flagShowReset={false}
                                                      searchFormOptions={searchFormOptions}
                                                      precondition={{
                                                          eventCode: 40,
                                                          auditStatus:0,
                                                          saveStatus:1,// 0:未保存(查询未保存过:待处理tap页) 1:未提交(查询保存过未提交:待审核tap页
                                                      }}
                                                      fetchApi={'/service/mg/sticker/track/list'} />
                                  </div>)
                              }:null,{
                                  key: '1',
                                  label:Lang({id: 'YiChuLi', default: '已处理'}),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columnsReviewed}
                                                      onRef={this.onRefTabTwo}
                                                      rowKey={'id'}
                                                      flagShowReset={false}
                                                      searchFormOptions={searchFormOptions}
                                                      precondition={{
                                                          eventCode: 40,
                                                          auditStatus:1,
                                                      }}
                                                      fetchApi={'/service/mg/sticker/track/list'}  />
                                  </div>)
                              }
                          ]}
                          onChange={(activeKey)=>this.changeTab(activeKey)}>
                    </Tabs>
                </div>
            </Spin>
        )
    }
}

export default CustomsCoding;
